<template>
  <div class="normal-text-content" v-html="answers.content"></div>
</template>
<script>
export default {
  name: "normalRender",
  props: {
    answers: {
      type: Array | Object,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.normal-text-content {
  text-align: left;
}
</style>
